import { useState, useEffect } from 'react';

const STATES = {
  LOAD: 10,
  INTRO: 20,
  PLAY: 30,
  DONE: 40,
  RELATED: 50,
};

const useGameState = (assetFunction) => {
  const [gameState, setGameState] = useState(STATES.LOAD);

  useEffect(() => {
    if (assetFunction) {
      Promise.all(assetFunction()).then(() => {
        setGameState(STATES.INTRO);
        window.setTimeout(() => setGameState(STATES.PLAY), 250);
      });
    } else {
      setGameState(STATES.INTRO);
      window.setTimeout(() => setGameState(STATES.PLAY), 250);
    }
  }, [assetFunction]);

  const setGameDone = () => {
    setGameState(STATES.DONE);
    window.setTimeout(() => setGameState(STATES.RELATED), 2000);
  };

  const setGamePlay = () => {
    setGameState(STATES.PLAY);
  };

  return [gameState, setGameDone, setGamePlay];
};

export default useGameState;
export { STATES };
